export const models = {
  advertiser: {
    id: 'id',
    name: 'name',
    agencyId: 'agency id',
    agencyName: 'agency name',
    anAdvertiserId: 'app nexus advertiser id',
    code: 'code',
    email: 'email',
    staffName: 'staff name',
    status: 'status',
    tel: 'tel',
  },
}
